export default __webpack_public_path__ + "static/media/omar.f7a1f46b.png";